import { GenIcon } from '../helpers/IconBase.es.js';

const CheckOutlined = (props) => {
    return GenIcon({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M5 12.4545L9.375 17L19 7',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    })(props);
};

export { CheckOutlined };
